<template>
  <div class="home">
    <div class="home_header">
      <div class="home_header_opt">
        <p>桌台状态</p>
      </div>
      <img :style="transformClass" src="../../static/images/search.png" @click="searchFn()" />
      <i class="el-icon-switch-button" @click="logoOut()"></i>
    </div>

    <!-- 桌台 -->
    <div class="home_content" @click="menuShow=false">
      <ul class="content_nav">
        <li v-for="(i, index) in tableInfo" @click="tabSelect(index)" :class="{active:index == selectIndex}"
          v-if="i.shopTableList.length > 0">
          <img src="../../static/images/hall.png" alt="" />
          <span>{{i.name}}</span>
        </li>
      </ul>
      <ul class="content_tab">
        <li v-for="(i, index) in currTable" :class="{select:i.status == 3}" @click="tabClick(i)">
          <h3>{{i.title}}</h3>
          <p class="content_money" v-if="i.status == 3">￥{{i.payMoney || 0}}</p>
          <p class="content_num" v-else-if="i.status == 0 || i.status == 5">可供{{i.seatNum}}人</p>
          <span v-if="i.id == i.joinTableId && i.operateStatus == 1">并</span>
          <span v-else-if="i.id == i.joinTableId && i.operateStatus == 2">拆</span>
          <span v-else-if="i.joinTableId && i.id!=i.joinTableId">子</span>
          <i class="el-icon-lock" v-if="i.lockStatus == 1"></i>
          <h4 v-show="i.status == 5">脏</h4>
        </li>
      </ul>
    </div>

    <!-- <div class="home_footer">
      <span @click="tabStatus(0)">全部 {{n}}</span>
      <span @click="tabStatus(1)">已开台 {{n2}}</span>
      <span @click="tabStatus(2)">未开台 {{n3}}</span>
    </div> -->
    <div class="home_menu">
      <div class="home_menu_icon" @click.stop="menuShow=!menuShow">
        <img src="../../static/images/menu2.png" alt="图标" />
        <span>操作</span>
      </div>
      <div class="home_menu_item" v-if="menuShow">
        <div class="home_menu_item_list">
          <img src="../../static/images/table.png" alt="图标" />
          <span>桌台</span>
        </div>
        <div class="home_menu_item_wrap">
          <p @click="tabStatus(0)">全部 ({{n}})</p>
          <p @click="tabStatus(1)">已开台 ({{n2}})</p>
          <p @click="tabStatus(2)">未开台 ({{n3}})</p>
        </div>
        <div class="home_menu_item_list" @click="pageGoFn">
          <img src="../../static/images/order2.png" alt="图标" />
          <span>订单列表</span>
        </div>
      </div>
    </div>

    <!-- 操作 -->
    <div class="home_opt" v-if="optShow" @click="optShowFn">
      <div class="opt_wrap" @click.stop>
        <div class="opt_header">
          <div class="opt_header_msg">
            <div class="opt_shopName">{{shopName}}</div>
            <h5>当前桌台：{{selectInfo.title}}<i class="el-icon-lock" v-if="selectInfo.lockStatus == 1"></i></h5>
          </div>
          <h6 @click="logoOut()">
            <span class="el-icon-s-custom">{{userInfo.nickname}}</span>
            <i class="el-icon-arrow-down"></i>
          </h6>
        </div>
        <div class="opt_content clearFix">
          <p :class="{notOpt:selectInfo.lockStatus == 1 || selectInfo.status == 3}" @click="goRoomFn(1)">开台</p>
          <!--<p :class="{notOpt:selectInfo.lockStatus == 1}" @click="tabStatus(1, 1, '合并')">并台</p>
    				<p :class="{notOpt:selectInfo.lockStatus == 1}" @click="tabStatus(0, 1, '拆分')">拆台</p>-->
          <p :class="{notOpt:selectInfo.lockStatus == 1 || selectInfo.status != 3}" @click="ombinedFn()">并台</p>
          <p :class="{notOpt:selectInfo.lockStatus == 1}" @click="dismantleFn()">拆台</p>
          <p :class="{notOpt:selectInfo.lockStatus == 1 || selectInfo.status == 3 && selectInfo.payMoney > 0
          || selectInfo.status == 0}" @click="goRoomFn(6)">清台</p>
          <p :class="{notOpt:selectInfo.lockStatus == 1}" @click="goRoomFn(8)" v-if="selectInfo.lockStatus != 1">锁台</p>
          <p :class="{notOpt:selectInfo.lockStatus == 0}" @click="goRoomFn(9)" v-else>解锁</p>
          <p :class="{notOpt:selectInfo.lockStatus == 1 || selectInfo.status != 3}" @click="goRoomFn(12)">催菜</p>
          <p :class="{notOpt:selectInfo.lockStatus == 1 || selectInfo.status != 3}" @click="goRoomFn(10)">复制桌台</p>
          <p :class="{notOpt:selectInfo.lockStatus == 1 || selectInfo.status != 3}" @click="goRoomFn(11)">转菜品</p>
          <p :class="{notOpt:selectInfo.lockStatus == 1}" @click="goRoomFn(2)">
            {{selectInfo.lockStatus == 1 || selectInfo.status != 3 ? '点' : '加'}}菜
          </p>
          <p :class="{notOpt:selectInfo.lockStatus == 1 || selectInfo.status != 3}" @click="goRoomFn(3)">退菜</p>
          <p :class="{notOpt:selectInfo.lockStatus == 1 || selectInfo.status != 3}" @click="goRoomFn(7)">结算</p>
        </div>
      </div>
    </div>

    <!-- 提示脏台弹窗 -->
    <div class="dirty" v-if="dirtyPrompt" @click="dirtyPrompt=false">
      <div class="dirty_content" @click.top>
        <div class="dirty_header">
          <i class="el-icon-close" @click="dirtyPrompt=false"></i>
        </div>
        <div class="dirty_note">
          <h2>该桌台为脏台！</h2>
          <h2>是否清台并开台</h2>
        </div>
        <div class="dirty_btn">
          <el-button type="primary" @click="submitDirty()">确定</el-button>
          <el-button type="primary" @click="dirtyPrompt=false">取消</el-button>
        </div>
      </div>
    </div>

    <!-- 设置并台拆台的桌台弹窗 -->
    <div class="opt_PopUps" v-if="optTab" @click="optTab=false">
      <div class="opt_tab" @click.stop>
        <div class="tab_header">
          <h3>正在操作【{{selectInfo.title}}】桌台</h3>
          <div @click="optTab=false">
            <img src="../../static/images/close_icon.png" alt="" />
          </div>
        </div>
        <div class="tab_content">
          <ul class="content_title">
            <li v-for="(i, index) in optInfo" @click="switchTab(index)" :class="{select:index == tabIndex}"
              v-if="i.shopTableList.length>0">{{i.name}}</li>
          </ul>
          <ul class="content_list">
            <li v-for="(i, index) in optInfoTab" @click="selectTab(i)" :class="{select:i.isSelect == true}"
              v-if="i.status == 3 && i.id != selectInfo.id && i.lockStatus != 1">
              {{i.title}}
              <span v-if="i.id == i.joinTableId && i.operateStatus == 1">并</span>
              <span v-else-if="i.id == i.joinTableId && i.operateStatus == 2">拆</span>
              <span v-else-if="i.joinTableId && i.id!=i.joinTableId">子</span>
            </li>
          </ul>
          <div class="tab_opt">
            <el-button type="primary" @click="tabSubmit(0)" :disabled="optDisable">并台</el-button>
            <el-button type="primary" @click="optTab=false">取消</el-button>
          </div>
        </div>
      </div>
    </div>

    <!-- 开台-清台弹窗 -->
    <div class="dirty" v-if="windowShow" @click="windowShow=false">
      <div class="dirty_content" @click.stop>
        <div class="dirty_title">
          <h2>开台</h2>
          <i class="el-icon-close" @click="windowShow=false"></i>
        </div>
        <div class="dirty_item">
          <h6><span>*</span>就餐人数：</h6>
          <p>
            <el-input type="number" v-model="eatNum" placeholder="人数(不填默认1)" @focus="focus($event)" clearable>
            </el-input>
          </p>
        </div>
        <div class="dirty_item">
          <h6>开台备注：</h6>
          <p>
            <el-input v-model="eatRemarks" placeholder="备注内容" @focus="focus($event)" clearable></el-input>
          </p>
        </div>
        <div class="dirty_btn">
          <el-button type="primary" @click="confirmFn">确定</el-button>
          <el-button type="primary" @click="windowShow=false">取消</el-button>
        </div>
      </div>
    </div>

    <!-- 复制桌台-选桌台 -->
    <div class="opt_PopUps" v-if="copyShow" @click="copyShow=false">
      <div class="opt_tab" @click.stop>
        <div class="tab_header">
          <h3>正在操作【{{selectInfo.title}}】桌台</h3>
          <div @click="copyShow=false">
            <img src="../../static/images/close_icon.png" alt="" />
          </div>
        </div>
        <div class="tab_content">
          <ul class="content_title">
            <li v-for="(i, index) in tableInfo" v-if="i.shopTableList.length>0" :class="{select:index == copyIndex}"
              @click="copySelectFn(i, index)">{{i.name}}</li>
          </ul>
          <ul class="content_list">
            <li v-for="(i, index) in currList" v-if="i.id != selectInfo.id" :class="{select:i.copySelect}"
              @click="copyClickFn(i, 1)">{{i.title}}</li>
          </ul>
          <div class="tab_opt">
            <el-button type="primary" @click="copyConfirm">确定</el-button>
            <el-button type="primary" @click="copyShow=false">取消</el-button>
          </div>
        </div>
      </div>
    </div>

    <!-- 转菜品/退菜 -->
    <div class="opt_PopUps" v-if="turnShow" @click="turnShow=false">
      <div class="opt_tab" @click.stop>
        <div class="tab_header">
          <h3>【{{selectInfo.title}}】{{optType == 3 ? '退菜' :  optType == 4 ? '催菜' : '转菜'}}选择</h3>
          <div @click="turnShow=false">
            <img src="../../static/images/close_icon.png" alt="" />
          </div>
        </div>
        <div class="tab_content">
          <ul class="content_item">
            <li v-for="(i, index) in tabInfo.orderItem" v-if="i.status != 0" @click="copyClickFn(i, 2)"
            :class="{select:i.copySelect, disClass:i.returnfoodnumber > 0 && i.returnfoodnumber >= i.qty}">
              <h6><b v-if="i.canteenStatus >= 0 && (i.returnfoodnumber <= 0 || i.returnfoodnumber < i.qty)">[{{statusList[i.canteenStatus].name}}]</b>{{i.foodName}}</h6>
              <h5>￥{{i.price}}/{{i.qty}}{{i.unit}}</h5>
              <p>{{i.remarkName}}</p>
            </li>
          </ul>
          <div class="tab_opt tab_opt2">
            <div class="tab_opt_msg" v-if="optType != 3">
              <el-checkbox v-model="allChecked" @change="allCheckedFn">全选</el-checkbox>
            </div>
            <div class="tab_opt_btn">
              <el-button type="primary" @click="turnConfirm">确定</el-button>
              <el-button type="primary" @click="turnShow=false">取消</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import qs from 'qs';
  import { interfaceFn, timeFn } from '@/assets/util';
  import phoneUUID from '@/assets/phoneUUID';
  export default {
    data () {
      return {
        name: 'Home',
        transformClass: '', //刷新的动图
        time: 0,
        tableInfo: [], //桌台信息
        selectIndex: 0, //默认选中的区域
        currTable: [], //当前页面的桌台信息
        n: 0, //全部
        n2: 0, //已开台
        n3: 0, //未开台
        optTab: false, //操作桌台弹窗
        optTitle: '', //操作桌台title
        optInfo: [], //操作桌台的info
        optInfoTab: [], //操作桌台对应的桌台
        tabIndex: 0, //操作桌台默认选中第一个
        tabModel: 0, //0合并 1拆台
        curTabName: '', //拆台当前点击的桌台名称
        dirtyPrompt: false, //脏台弹窗
        curTableId: '', //当前点击的桌台id
        optDisable: false, //操作确定响应前只能点击一次

        optShow: false,
        userInfo: {}, // 用户信息
        selectInfo: {}, // 选中的桌台

        eatNum: 1,
        eatRemarks: '',
        windowShow: false,

        // 复制桌台
        copyShow: false,
        currList: [], // 当前所有未开台的
        copyIndex: 0,

        // 转菜品
        allChecked: false,
        tabInfo: {},
        turnShow: false,
        optType: 1, // 1复制桌台，2转菜品，3退菜，4催菜
        shopName: '',
        menuShow: false,
        statusList: [{id: 0,name: '新品'}, {id: 1,name: '不厨打'}, {id: 2,name: '厨打'}, {id: 3,name: '等叫'}
        	, {id: 4,name: '叫起'}, {id: 5,name: '催菜'}, {id: 6,name: '划菜'}, {id: 7,name: '退菜'}],
      }
    },

    created() {
      setInterval(() => {
        phoneUUID(1)
      }, 15*60*1000);
      this.init();
    },
    mounted() {
      //  		console.log(this.$store.state.first);
    },

    // updated() {
    //   this.n = this.currTable.length;
    //   var m = 0;
    //   for (var i = 0; i < this.currTable.length; i++) {
    //     if (this.currTable[i].status == 3) {
    //       m += 1;
    //     }
    //   }
    //   this.n2 = m;
    //   this.n3 = this.n - this.n2;
    // },
    destroyed(){
      // 清除所有定时器
      let end = setInterval(function () { }, 10);
      for (let i = 1; i <= end; i++) {
          clearInterval(i);
      }
    },

    methods: {
      dianwo(){
        let id = setTimeout(() => {  }, 0);
        while(id > 0){
          window.clearTimeout(id)
          id --;
        }
      },
      init(index) {
        try {
          var shopCode = JSON.parse(window.localStorage.getItem('logindata')).shopCode;
          this.userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
          window.localStorage.removeItem('payBack');
          window.localStorage.removeItem('foodsInfo'); // 移除localStorage的菜品信息
          this.$store.state.memberInfo = {};
          var goSelectTab = window.localStorage.getItem('goSelectTab');
          if (goSelectTab != 1) { //判断是否是转桌台操作
            window.localStorage.removeItem('curClickInfo');
            window.localStorage.removeItem('cartInfo');
            window.localStorage.removeItem('oldCartList');
            window.localStorage.removeItem('newCartList');
            window.localStorage.removeItem('allFoodsMoney');
            window.localStorage.removeItem("goSelectTab");
            window.localStorage.removeItem("allPrices");
            window.localStorage.removeItem("oldTableId");
            window.localStorage.removeItem("originaltableId");
            window.localStorage.removeItem("cashPledge");
            window.localStorage.removeItem('noteInfo');
            window.localStorage.removeItem('externalId');

            //加载门店桌台信息
            let loadingInstance = this.$loading({
              fullscreen: true
            });
            this.$http.get(interfaceFn() + '/getfoodbycode?code=' + shopCode).then((res) => {
              loadingInstance.close();
              var tableInfo = res.data.table;
              this.$store.state.tabList = tableInfo;
//            this.getShopInfo(tableInfo[0].shopId);

              /* 添加全部 */
              var allTable = {
                name: '全部',
                merchantId: tableInfo[0].merchantId,
                shopId: tableInfo[0].shopId,
                shopTableList: []
              }
              for (var i = 0; i < tableInfo.length; i++) {
                for (var j = 0; j < tableInfo[i].shopTableList.length; j++) {
                  allTable.shopTableList.push(tableInfo[i].shopTableList[j]);
                }
              }
              this.tableInfo = tableInfo;
              this.tableInfo.unshift(allTable);
              this.currTable = this.tableInfo[0].shopTableList;
              this.n = this.currTable.length;
              let n2 = this.currTable.filter(f => f.status == 3);
              this.n2 = n2.length;
              let n3 = this.currTable.filter(f => f.status == 0);
              this.n3 = n3.length;
              this.selectIndex = 0;
              if (index) { //默认选中清台选中的页面
                this.currTable = this.tableInfo[index].shopTableList;
                this.selectIndex = index;
              }

              window.localStorage.setItem("merchantId", this.tableInfo[0].merchantId); //设置菜品信息
              window.localStorage.setItem("shopId", this.tableInfo[0].shopId); //设置菜品信息

              //加载菜品信息 priceType：服务员点餐：0，扫码点餐：1
              this.$http.get(interfaceFn() + '/merchantFood/getFoodDataByCode?priceType=0&code=' + shopCode).then((info) => {
                //增加num字段
                var foodsList = info.data.list;
                foodsList.filter(i => {
                  i.num = 0;
                  i.subCategoryFoods.filter(p => {
                    p.filter(j => {
                      j.num = 0;
                      j.bigCategoryId = i.foodCategoryId;
                      j.isFormat = false; // 增加字段，即是否存在选规格口味项
                      let len = j.foodAddEntity.length + j.foodSugarEntity.length + j.foodTemperatureEntity.length
                      + j.foodTopEntity.length + j.foodsize.length + j.foodtasetEntity.length + j.foodOtherEntity.length;
                      if (len > 0) {
                        j.foodsize.unshift({
                          barcode: j.barcode,
                          code: j.code,
                          cost: j.cost,
                          createTime: j.createTime,
                          foodId: j.foodId,
                          id: j.id,
                          merchantId: j.merchantId,
                          retailPrice: j.finalPrice,
                          shopId: j.shopId,
                          title: j.title,
                          updateTime: j.updateTime,
                          vipPrice: j.vipPrice,
                          weixin: j.finalPrice
                        });
                        j.isFormat = true;
                      }
                    })
                  })
                });

                var allFood = {
                  foodCategory: '全部',
                  num: 0,
                  foods: []
                }

                //处理热门菜品显示
                foodsList.forEach((f, index) => {
                  if (f.foodCategory == "热门菜品") {
                    f.subCategoryFoods = [f.foods];
                    f.subCategoryName.push("热门菜品");
                    f.subCategoryFoods.filter(h => {
                      h.filter(k => {
                        k.num = 0;
                        k.isFormat = false; // 增加字段，即是否存在选规格口味项
                        let len = k.foodAddEntity.length + k.foodSugarEntity.length + k.foodTemperatureEntity.length +
                          k.foodTopEntity.length + k.foodsize.length + k.foodtasetEntity.length + k.foodOtherEntity.length;
                        if (len > 0) {
                          k.foodsize.unshift({
                            barcode: k.barcode,
                            code: k.code,
                            cost: k.cost,
                            createTime: k.createTime,
                            foodId: k.foodId,
                            id: k.id,
                            merchantId: k.merchantId,
                            retailPrice: k.retailPrice,
                            shopId: k.shopId,
                            title: k.title,
                            updateTime: k.updateTime,
                            vipPrice: k.vipPrice,
                            weixin: k.finalPrice
                          });
                          k.isFormat = true;
                        }
                      });
                    })
                  }
                })

                // 删除空分类
                foodsList.forEach((f, index) => {
                  if (f.subCategoryFoods.length <= 0) {
                    foodsList.splice(index, 1);
                  }
                })

                let listArr = [];
                foodsList.forEach((i, index) => {
                  i.subCategoryFoods.forEach((f, indexs) => {
                    let temp = i.subCategoryName[indexs];
                    let temps = i.foodCategory;
                    let sumName = temps != temp ? temps : '';
                    f.unshift({
                      names: temp,
                      foodCategory: sumName
                    });
                    listArr.push(...f);
                  })
                })

                allFood.foods = listArr;
                foodsList.unshift(allFood);

                this.$store.state.foodsInfo = foodsList; //设置菜品信息
                // console.log(foodsList);
              });

              window.localStorage.setItem("model", res.data.model); //设置点餐模式
              window.localStorage.setItem("shopName", res.data.shopname); //设置门店名称
            }).catch(() => {
              loadingInstance.close();
            });
          } else {
            this.tabStatus(2);
          }
        } catch (e) {
          this.msgFn('warning', '系统错误，请联系开发人员', 1500);
          alert(JSON.stringify(e));
        }
      },

      // 获取门店信息
      getShopInfo(id) {
        this.$http.get(interfaceFn() + '/shopService/get?shopId=' + id
        + '&type=6&diskSerialNumber=' + localStorage.getItem('Phoneuuid')).then((res) => {
          if (res.data.returnCode == 'ok') {
            let result = res.data.result;
            if (result.online == 0) {
              localStorage.clear();
              this.$router.push({ path: '/' });
              this.$alert('已被踢出下线！', '下线通知', {
                confirmButtonText: '确定',
                callback: action => {}
              });
              return;
            }
            this.shopName = result.name;
            this.$store.state.shopInfo = result; // 全局设置门店信息
          }
        })
      },

      /* 点击input选择状态 */
      focus(event) {
        event.currentTarget.select();
      },

      pageGoFn () {
        this.$router.push({
          path: "/orderlist"
        });
      },
      //刷新页面
      searchFn() {
        if (this.time == 0) {
          this.init();
          this.transformClass = '--angle:'
          + (this.transformClass ? parseInt(this.transformClass.replace(new RegExp('\\D', 'g'), '')) + 360 : 360) + 'deg';
          this.time = 2;
        } else {
          this.msgFn('warning', '刷新频繁,请稍后重试', 500);
        }

        setTimeout(() => {
          this.time = 0;
        }, 2000);
      },

      // 操作桌台
      optShowFn() {
        this.optShow = false;
        this.selectInfo = {};
        window.localStorage.removeItem("curClickInfo");
        window.localStorage.removeItem("originaltableId");
      },

      //tab页切换
      tabSelect: function(index) {
        this.currTable = this.tableInfo[index].shopTableList;
        this.selectIndex = index;
      },

      //获取桌台状态
      tabStatus(id) {
        this.menuShow = false;

        // 锁台不能进行其他操作
        if (this.selectInfo.lockStatus == 1) {
          this.msgFn('warning', '请先进行解锁', 1500);
          return;
        }
        if (id != 2) this.optShowFn();
        this.$http.post(interfaceFn() + '/getTableStatus',
          qs.stringify({
            code: JSON.parse(window.localStorage.getItem('logindata')).shopCode,
            type: id,
          }), {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          }).then((res) => {
          var tableInfo = res.data.table;
          this.selectIndex = 0;
          for (var i = 0; i < tableInfo.length; i++) {
            tableInfo[i].name = tableInfo[i].categoryName;
            delete tableInfo[i].categoryName;
            tableInfo[i].shopTableList = tableInfo[i].categoryTable;
            delete tableInfo[i].categoryTable;
          }

          this.tableInfo = tableInfo;

          /* 添加全部 */
          var shopTableList = {
            name: '全部',
            merchantId: tableInfo[0].merchantId,
            shopId: tableInfo[0].shopId,
            shopTableList: []
          }
          for (var i = 0; i < this.tableInfo.length; i++) {
            for (var j = 0; j < this.tableInfo[i].shopTableList.length; j++) {
              shopTableList.shopTableList.push(this.tableInfo[i].shopTableList[j]);
            }
          }

          this.tableInfo.unshift(shopTableList);
          this.currTable = this.tableInfo[0].shopTableList;
          /*if (status != 1) {
          } else {
          	this.optInfo = tableInfo;
          	this.optTitle = info;
          	if (info == '合并') {
          		this.tabModel = 0;
          	} else {
          		this.tabModel = 1;
          	}
          	this.optTab = true;
          	this.optInfoTab = this.optInfo[0].categoryTable;
          	if (this.tabIndex) {//操作桌台显示当前操作的tab页
          		this.optInfoTab = this.optInfo[this.tabIndex].categoryTable;
          	}
          	for (var i = 0; i < this.optInfo.length; i++) {
          		for (var j = 0; j < this.optInfo[i].categoryTable.length; j++) {
          			this.optInfo[i].categoryTable[j].isSelect = false;
          		}
          	}
          }*/
        }).catch((error) => {});
      },

      //退出操作
      logoOut() {
        this.$confirm('确认退出当前登录的账户', this.userInfo.nickname, {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
           // 获取用户登录手机型号和uuid
          phoneUUID(0)
          let logindata = window.localStorage.getItem("logindata");
          let Phoneid = window.localStorage.getItem("Phoneuuid")
          window.localStorage.clear()
          window.localStorage.setItem("Phoneuuid",Phoneid)
          window.localStorage.setItem("logindata", logindata);
          this.$store.state.first = 1;
          let loadingInstance = this.$loading({
            fullscreen: true
          });
          this.msgFn('success', '正在进行退出操作', 1500);

          setTimeout(() => {
            loadingInstance.close();
            this.$router.push({
              path: "/"
            });
          }, 1500);
        }).catch(() => {});
      },

      //操作切换tab页
      switchTab(index) {
        this.optInfoTab = this.tableInfo[index].shopTableList;
        this.tabIndex = index;
      },

      //选中桌台
      selectTab(info) {
        info.isSelect = !info.isSelect;
        this.curTabName = info.title;
        this.$forceUpdate();
      },

      //操作确认解除按钮--并台确认
      tabSubmit(type) {
        this.optDisable = true;
        setTimeout(() => {
          this.optDisable = false;
        }, 1500); //一秒钟之内禁止重复点击
        let selectId = [];
        let list = this.tableInfo[0].shopTableList.filter(f => f.status == 3 && f.isSelect);
        if (type == 0 && list.length == 0) {
          this.msgFn('warning', '至少选择一个桌台进行合并', 1500);
          return;
        }
        list.unshift(this.selectInfo);
        list.filter(f => selectId.push(f.id));
        this.$http.post(interfaceFn() + '/shopTable/mergeTableMulti',
          qs.stringify({
            shopId: window.localStorage.getItem('shopId'),
            tableIds: selectId.join(','),
            type: type
          }), {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          }).then((res) => {
          this.optShow = false;
          this.optTab = false;
          this.msgFn(res.data.returnCode == 'ok' ? 'success' : 'error', res.data.message, 1000);
          this.searchFn();
        });
      },

      // 拆台-解除拆台
      dismantleFn() {
        let info = this.selectInfo;
        let type = info.id == info.joinTableId || !info.joinTableId ? 0 : 1;
        if (info.lockStatus == 1) {
          this.msgFn('warning', '请先进行解锁', 1500);
          return;
        }
        this.$confirm('确定' + (type == 0 ? '拆分' : '解除') + '此桌台？', info.title, {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.post(interfaceFn() + '/shopTable/breakUpTable',
            qs.stringify({
              shopId: info.shopId,
              tableId: info.id,
              type: type,
              title: info.title
            }), {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded"
              }
            }).then((res) => {
            this.optShow = false;
            this.msgFn(res.data.returnCode == 'ok' ? 'success' : 'error', res.data.message, 1000);
            this.searchFn();
          })
        }).catch(() => {});
      },

      // 并台
      ombinedFn() {
        let info = this.selectInfo;
        if (info.lockStatus == 1) {
          this.msgFn('warning', '请先进行解锁', 1500);
          return;
        }
        if (info.status != 3) {
          this.msgFn('warning', '该桌台不能进行此项操作', 1500);
          return;
        }

        if (info.operateStatus == 1) {
          this.tabSubmit(1); // 并台解除
        } else {
          this.optTab = true;
          this.optShow = false;
          this.optTitle = '并台正在操作【' + info.title + '】';
          this.optInfo = this.tableInfo;
          this.optInfoTab = this.tableInfo[0].shopTableList;
        }
      },

      //脏台弹窗确认按钮
      submitDirty() {
        this.$http.post(interfaceFn() + '/shopTable/cleanTable',
          qs.stringify({
            shopId: window.localStorage.getItem('shopId'),
            tableId: this.curTableId
          }), {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          }).then((res) => {
          if (res.data.returnCode == 'error') {
            this.msgFn('error', res.data.message, 1000);
          } else {
            this.msgFn('success', res.data.message, 1000);
            this.init(this.selectIndex);
          }
          this.dirtyPrompt = false;
        }).catch((error) => {});
      },

      //当前点击的桌台
      tabClick(info) {
        try {
          var goSelectTab = window.localStorage.getItem('goSelectTab');
          var curClickInfo = JSON.parse(window.localStorage.getItem('curClickInfo'));
          this.curTableId = info.id;

          //判断是否是脏台
          if (info.status == 5) {
            this.dirtyPrompt = true;
            return;
          }

          if (goSelectTab == 1) { //更换桌台的操作
            info.employeeId = curClickInfo.employeeId;
            info.payMoney = curClickInfo.payMoney;
            info.mealsNumbel = curClickInfo.mealsNumbel;
            window.localStorage.setItem('oldTableId', curClickInfo.id); //设置转台前的桌台id
            window.localStorage.setItem('curClickInfo', JSON.stringify(info)); //设置当前桌台状态的缓存
            this.$router.push({
              path: "/pay"
            });

          } else {
            this.optShow = true;
            this.selectInfo = info;
            window.localStorage.setItem('curClickInfo', JSON.stringify(info)); //设置当前桌台状态的缓存
            window.localStorage.setItem('originaltableId', info.id); //设置当前桌台状态的缓存
            if (!this.shopName) {
              this.shopName = localStorage.getItem('shopName');
            }
            //this.$router.push({path: "/room"});
          }
        } catch (e) {
          this.msgFn('warning', '系统错误，请联系开发人员', 1500);
          alert(JSON.stringify(e));
        }
      },

      // 操作按钮 -- 1：开台，2：点餐，3：退菜，4：叫起，5：催菜，6：清台，
      // 7：结算/菜单，8：锁台，9：解锁，10复制桌台，11转菜品，12催菜
      goRoomFn(n) {
        var _this = this;
        let purview = this.userInfo.userThronesEntity; // 权限
        if (this.selectInfo.lockStatus == 0 && n == 9) {
          this.msgFn('warning', '不能进行解锁', 1500);
          return; // 未锁桌台不能进行解锁操作
        } else if (this.selectInfo.lockStatus == 1 && n != 9) {
          this.msgFn('warning', '请先进行解锁', 1500);
          return; // 锁台不能进行其他操作
        }
        // this.optType = n;
        if (n == 1) {
          if (purview.isOpenTable == 0) {
            this.msgFn('warning', '暂无开台权限', 1500);
            return;
          }

          this.optShow = false;
          if (this.selectInfo.status != 0 || this.selectInfo.status == 3) {
            this.msgFn('warning', '不能进行开台', 1500);
            return;
          }
          this.windowShow = true;
        } else if (n == 2) {
          // 权限
          if (purview.isOrderFood == 0) {
            this.msgFn('warning', '暂无点餐权限', 1500);
            return;
          } else if (purview.isDownOrder == 0 && purview.isOpenTable == 0) {
            this.msgFn('warning', '暂无开台权限', 1500);
            return;
          }

          this.$router.push({
            path: "/room"
          });
          // this.tableOperate(1, '锁台', null, true);
        } else if (n == 6) {
          // console.log(this.selectInfo);
          if (this.selectInfo.status == 3 && this.selectInfo.payMoney > 0 || this.selectInfo.status == 0) {
            this.msgFn('warning', '不能进行清台', 1500);
            return;
          }
          if (purview.isCleanTable == 0) {
            this.msgFn('warning', '暂无清台权限', 1500);
            return;
          }

          reqFn(3, '清除桌台', '确认清除此桌台？')
        } else if (n == 7) {
          if (this.selectInfo.status != 3) {
            this.msgFn('warning', '不能进行结算', 1500);
            return;
          }
          window.localStorage.setItem('byTo', 'pay')
          this.$router.push({
            path: "/room"
          });
          // this.tableOperate(1, '锁台', null, true);
        } else if (n == 8) {
          reqFn(1, '锁台', '确认进行锁台？')
        } else if (n == 9) {
          reqFn(2, '解锁', '确认进行解锁？')
        } else if (n == 10) {
          if (this.selectInfo.status != 3) {
            this.msgFn('warning', '不能进行复制', 1500);
            return;
          }
          this.optType = 1;
          this.optShow = false;
          this.copyShow = true;
          this.currList = this.tableInfo[0].shopTableList.filter(f => f.status == 0);
          this.currList.filter(f => f.copySelect = false);
        } else if (n == 11 || n == 3 || n == 12) {
          this.optType = 2;
          let obj = '';
          if (this.selectInfo.status != 3 && n == 11) {
            this.msgFn('warning', '不能进行转菜品', 1500);
            return;
          }
          if (n == 3) {
            this.optType = 3;
            obj = '&findMerge=0';
            if (this.selectInfo.lockStatus == 1 || this.selectInfo.status != 3) {
              this.msgFn('warning', '暂未有相关菜品可以操作', 1500);
              return;
            }
          }
          if (n == 12) {
            this.optType = 4;
            obj = '&findMerge=0';
            if (this.selectInfo.lockStatus == 1 || this.selectInfo.status != 3) {
              this.msgFn('warning', '暂不能进行此项操作', 1500);
              return;
            }
          }

          // 获取当前桌台的菜品
          this.$http.get(interfaceFn() + '/getfoodOrder?sho=' + this.selectInfo.shopId
          + '&tab=' + this.selectInfo.id + obj).then((res) => {
            if (res.status == 200) {
              if (res.data.order) {
                let data = JSON.parse(res.data.order);
                data.orderItem.filter(f => {
                  let remark = [],
                    newArr = [];
                  if (f.remark) { // 有重复项判断
                    remark = f.remark.split('{').join('').split('}').join('').split('"').join('').split(',');
                  }
                  remark.filter(k => newArr.push(k.split(':')[0]));
                  f.remarkName = newArr.join(',');
                })
                let orderList = data.orderItem.filter(f => f.status != 0);
                if (orderList.length == 0) {
                  this.msgFn('warning', '该桌台未下单不能进行此项操作', 2000);
                  return;
                }
                this.tabInfo = data;
                this.optShow = false;
                this.turnShow = true;
                this.allChecked = false;
              } else {
                this.msgFn('warning', '该桌台不无菜品可操作', 2000);
              }
            }
          })
        }

        function reqFn(obj, note, title) {
          _this.$confirm(title, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            _this.tableOperate(obj, note);
          }).catch(() => {});
        }
      },

      // 桌台操作
      tableOperate(obj, remark, num, opt) {
        let _this = this;
        let info = {
          shopId: window.localStorage.getItem('shopId'),
          tableId: this.curTableId,
          userId: this.userInfo.id,
          operate: obj, // 0：单纯开台不点餐，1：锁台，2：解锁,3:清台
          remark: remark,
          mealsNumber: num || 1,
        }
        this.$http.post(interfaceFn() + '/shopTable/tableOperate',
          qs.stringify(info), {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          }).then((res) => {
          if (!opt) {
            this.msgFn(res.data.returnCode == 'ok' ? 'success' : 'error'
            , remark + (res.data.returnCode == 'ok' ? '成功' : '失败'), 1000);
            this.windowShow = false;
            // _this.searchFn();
            this.optShowFn();

            setTimeout(function() {
              _this.searchFn();
            }, 500)

          }

          /*if (obj == 0) {
          	this.searchFn();
          	this.windowShow = false;
          	window.localStorage.setItem('noteInfo', JSON.stringify({
          		eatNum: this.eatNum,
          		remarks: '',
          	}));
          	this.$router.push({path: "/room"});
          } else if (obj == 3) {
          	this.optShowFn();
          }*/
        }).catch((err) => {
          if (!opt) this.msgFn('error', '服务器错误，请稍后重试', 1000);
        });
      },

      // 桌台操作确认 1：开台
      confirmFn() {
        if (this.optType == 1) {
          this.tableOperate(0, this.eatRemarks, this.eatNum);
          // this.searchFn();
        }
      },

      // 复制桌台选分类
      copySelectFn(i, index) {
        this.copyIndex = index;
        this.currList = this.tableInfo[index].shopTableList;
      },
      // 复制选中桌台
      copyClickFn(i, n) {
        if (n == 1) {
          if (this.optType == 1) {
            i.copySelect = !i.copySelect;
          } else if (this.optType == 2) {
            this.tableInfo[0].shopTableList.filter(f => f.copySelect = false);
            i.copySelect = true;
          }
        } else if (n == 2) {
          if (this.optType == 3) {
            if (i.returnfoodnumber > 0 && i.qty <= 0) {
              this.msgFn('warning', '已退菜不能重复操作', 1500);
              return;
            }
            this.tabInfo.orderItem.filter(f => f.copySelect = false);
            i.copySelect = true;
          } else {
            if (this.optType == 4) {
              if (i.canteenStatus > 5) {
                this.msgFn('warning', '暂不能操作', 1500);
                return;
              } else if (i.returnfoodnumber > 0 && i.returnfoodnumber >= i.qty) {
                this.msgFn('warning', '退菜不能操作', 1500);
                return;
              }
            }
            i.copySelect = !i.copySelect;
          }

          let hasList = this.tabInfo.orderItem.filter(f => f.copySelect);
          this.allChecked = hasList.length == this.tabInfo.orderItem.length;
        }
        this.$forceUpdate();
      },
      // 全选
      allCheckedFn (val) {
        this.tabInfo.orderItem.filter(f => {
          if (f.returnfoodnumber > 0 && f.returnfoodnumber >= f.qty) {} else {
            f.copySelect = val;
          }
        });
      },
      // 复制桌台确认
      copyConfirm() {
        // 选中的桌台
        let list = this.tableInfo[0].shopTableList.filter(f => f.copySelect);
        if (list.length == 0) {
          this.msgFn('warning', '请选择要操作的桌台', 1500);
          return;
        }
        if (this.optType == 1) {
          let tableName = [];
          list.filter(f => tableName.push(f.title));
          this.$confirm('确认将【' + this.selectInfo.title + '】桌台的菜品复制到选中的【' + tableName.join('，') + '】桌台中？', '桌台复制', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            let ids = [];
            list.filter(f => ids.push(f.id));
            let loadingInstance = this.$loading({
              fullscreen: true
            });
            this.$http.post(interfaceFn() + '/shopTable/copyTable',
              qs.stringify({
                shopId: window.localStorage.getItem('shopId'),
                copyTableId: this.selectInfo.id,
                pasteTableIds: ids.join(','),
                operateId: JSON.parse(window.localStorage.getItem('userInfo')).id
              }), {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded"
                }
              }).then((res) => {
              loadingInstance.close();
              if (res.data.returnCode == 'ok') {
                this.copyShow = false;
                this.msgFn('success', res.data.message, 1000);
                window.localStorage.removeItem('curClickInfo');
                this.searchFn();
              } else {
                this.msgFn('warning', res.data.message, 1500);
              }
            }).catch((err) => {
              loadingInstance.close();
              this.msgFn('error', '服务器错误，请稍后重试', 1000);
            });
          }).catch(() => {});
        } else if (this.optType == 2) {
          let foodsList = this.tabInfo.orderItem.filter(f => f.copySelect);
          this.$http.post(interfaceFn() + '/shopTable/turnTableFood', {
            "shopId": window.localStorage.getItem('shopId'),
            "tableId": this.selectInfo.id,
            "toTableId": list[0].id,
            "operateId": JSON.parse(window.localStorage.getItem('userInfo')).id,
            "orderItems": foodsList
          }).then((res) => {
            if (res.data.returnCode == 'ok') {
              this.searchFn();
              this.copyShow = false;
              this.msgFn('success', '操作成功', 1000);
            } else {
              this.msgFn('warning', res.data.message, 1500);
            }
          }).catch((err) => {
            this.msgFn('error', '服务器错误，请稍后重试', 1000);
          });
        }
      },

      // 转菜品确认
      turnConfirm() {
        let foodsList = this.tabInfo.orderItem.filter(f => f.copySelect);
        if (foodsList.length == 0) {
          this.msgFn('warning', '请选择要操作的菜品', 1500);
          return;
        }
        if (this.optType == 3) {// 退菜
          let purview = this.userInfo.userThronesEntity;// 权限
          if (purview.backfood == 1 || this.userInfo.identity == 1) {
            this.backFoodFn(foodsList);
          } else {
            this.msgFn('warning', '暂无退菜权限', 1500);
          }
        } else if (this.optType == 4) {
          let tabInfo = JSON.parse(JSON.stringify(this.tabInfo));
          tabInfo.isFirstOrder = 0;
          tabInfo.orderItem.filter(f => {
            f.qty += f.returnfoodnumber;
            if (f.copySelect) {
              f.canteenStatus = 5;
              f.urgeNum += 1;
            }
          })
          this.clientOrderFn(tabInfo);
        } else {
          this.turnShow = false;
          this.copyShow = true;
          this.currList = this.tableInfo[0].shopTableList;
          this.currList.filter(f => f.copySelect = false);
        }
      },
      // 退菜操作
      backFoodFn (list) {
        if (list.length == 0) return;
        let info = list[0];
        let tabInfo = JSON.parse(JSON.stringify(this.tabInfo));
        tabInfo.isFirstOrder = 0;
        this.$prompt('请输入退菜数量', '退菜数量', {
        	confirmButtonText: '确定',
        	cancelButtonText: '取消',
        	inputPattern: /\S/,
          inputType: 'number',
        	inputValue: 1,
        	inputErrorMessage: '数量不能为空'
        }).then((reason) => {
          if (Number(reason.value) > info.qty) {
            this.msgFn('warning', '退菜数量不能大于已点的数量', 1500);
            return;
          }

          this.$prompt('请输入退菜理由', '理由输入', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputPattern: /\S/,
            inputPlaceholder: '退菜理由',
            inputValue: '无理由',
            inputErrorMessage: '请输入退菜理由'
          }).then(({ value }) => {
            tabInfo.orderItem.filter((f, index) => {
              f.qty += f.returnfoodnumber;
              if (f.copySelect) {
                f.returnfoodnumber += Number(reason.value);
                if (!f.remark) {
                  f.remark = [{name: '退菜:' + value, price: 0}];
                } else {
                  let hasObj = JSON.parse(f.remark);
                  f.remark = [];
                  for (let i in hasObj) {
                    f.remark.push({
                      name: i,
                      price: hasObj[i]
                    })
                  }
                  f.remark.push({name: '退菜:' + value, price: 0});
                }
                if (f.remark && f.remark.length > 0) {
                  let remarkList = [];
                  for (var j = 0; j < f.remark.length; j++) {
                  	var list = f.remark[j];
                  	remarkList.push('"' + list.name + '":' + list.price);
                  }
                  f.remark = "{" + remarkList.join(',') + "}";
                }
              }
            })

            this.clientOrderFn(tabInfo);
          }).catch(() => {});
        }).catch(() => {});
      },

      // 提交订单
      clientOrderFn (tabInfo) {
        tabInfo.createTime = timeFn('yyyy-MM-dd HH:mm:ss');
        this.$http.post(interfaceFn() + '/clientOrder',
        qs.stringify({
          jsonData: JSON.stringify(tabInfo)
        }), {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          }
        }).then((res) => {
          if (res.data.data == 'success') {
            this.msgFn('success', '操作成功', 1000);
            this.turnShow = false;
            this.init();
          } else {
            this.msgFn('error', res.data.message, 1000);
          }
        });
      },

      // 提示
      msgFn(type, msg, time) {
        this.$Message({
          duration: time,
          message: msg,
          center: true,
          type: type
        });
      },
    }
  }
</script>
<style scoped>
  @import "../../static/css/home.css";
</style>



// WEBPACK FOOTER //
// src/components/Home.vue